// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"513b0370","186":"a2ebf0f8","225":"4cb6906b","272":"3e55f635","372":"43204235","738":"2bb38d4c","841":"511201e6","849":"54d0bf01","856":"b6b7d60e"}[chunkId] + ".chunk.js";
};